import { render, staticRenderFns } from "./InformationCard.html?vue&type=template&id=709b7780&scoped=true&"
import script from "./InformationCard.js?vue&type=script&lang=js&"
export * from "./InformationCard.js?vue&type=script&lang=js&"
import style0 from "./InformationCard.scss?vue&type=style&index=0&id=709b7780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b7780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VImg,VRow})
